import { Flex } from 'antd';
import { DateTime, WeekdayNumbers } from 'luxon';
import React from 'react';

import {
    BORDER_MAIN,
    COLOR_MORE_DARK_GREY,
    FORMAT_DATE_DISPLAY_MONTH_SHORT,
    GAP_COLUMN_AGENDA,
    WEEKEND_DAYS,
} from '../const';
import { getValueByHeaderType } from '../functions';
import { ItemTaskType, ItemType } from '../types';
import CalendarItemMonth from './calendarItemMonth';
import CalendarTaskMonth from './calendarTaskMonth';

interface ICalendarAgendaTask {
    taskList: ItemTaskType[];
    itemList: ItemType[];
    agendaDate: string;
}

const CalendarAgendaDay: React.FC<ICalendarAgendaTask> = ({ taskList, itemList, agendaDate }) => {
    const agendaDateTime = DateTime.fromISO(agendaDate);

    const colorWeekend = WEEKEND_DAYS.has(agendaDateTime.weekday) ? 'red' : COLOR_MORE_DARK_GREY;

    return (
        <Flex
            justify={'center'}
            style={{
                borderBottom: BORDER_MAIN,
                padding: 10,
                color: COLOR_MORE_DARK_GREY,
            }}
            gap={GAP_COLUMN_AGENDA}
        >
            <Flex justify={'start'} gap={10} style={{ width: 160, color: colorWeekend }}>
                <div style={{ fontSize: 50 }}>{agendaDateTime.toFormat('dd')}</div>
                <Flex justify={'start'} vertical style={{ marginTop: 12 }}>
                    <div style={{ fontSize: 18 }}>
                        {getValueByHeaderType('dayWeek', agendaDateTime, false).valueDisplay}
                    </div>
                    <div
                        style={{
                            fontSize: 18,
                            fontWeight: 'bold',
                        }}
                    >
                        {agendaDateTime.toFormat(FORMAT_DATE_DISPLAY_MONTH_SHORT)}
                    </div>
                </Flex>
            </Flex>
            <Flex justify={'space-between'} vertical style={{ minHeight: (itemList.length + taskList.length) * 25 }}>
                {itemList.map((item) => {
                    return (
                        <CalendarItemMonth
                            key={item.id}
                            day={agendaDateTime.weekday as WeekdayNumbers}
                            item={item}
                            isInteractive={true}
                            staticSize={true}
                            currentDate={agendaDate}
                            isShowLeftDataPanel
                        />
                    );
                })}
                {taskList.map((task) => {
                    return <CalendarTaskMonth key={task.id} task={task} isShowLeftDataPanel />;
                })}
            </Flex>
        </Flex>
    );
};

export default CalendarAgendaDay;
